import { useEffect, useState } from "react";
import api from "@/lib/api";
import { TrendingUp, User, Truck, Wrench } from "lucide-react";

export default function ReportsPage() {
  const [top, setTop] = useState([]);
  const [mechs, setMechs] = useState([]);
  const [machines, setMachines] = useState([]);
  const [officine, setOfficine] = useState([]);
  const [selectedOff, setSelectedOff] = useState(null);
  const [stock, setStock] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/reports/top-products"),
      api.get("/reports/by-mechanic"),
      api.get("/reports/by-machine"),
      api.get("/officine-mobili"),
    ]).then(([r1, r2, r3, r4]) => {
      setTop(r1.data); setMechs(r2.data); setMachines(r3.data); setOfficine(r4.data);
    });
  }, []);

  const loadStock = async (oid) => {
    setSelectedOff(oid);
    const { data } = await api.get(`/officine-mobili/${oid}/stock`);
    setStock(data);
  };

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto">
      <div className="mb-6">
        <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-2">Analytics</div>
        <h1 className="font-display text-4xl font-black uppercase tracking-tight">Reports</h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-5">
        <Panel icon={TrendingUp} title="Ricambi più utilizzati (90g)">
          {top.length === 0 ? <Empty/> : top.slice(0,12).map((r,i)=>(
            <Row key={r.product_id} idx={i+1} primary={r.descrizione} sub={r.codice_interno} value={r.totale} unit="pz" />
          ))}
        </Panel>
        <Panel icon={User} title="Per meccanico (90g)">
          {mechs.length === 0 ? <Empty/> : mechs.map((r,i)=>(
            <Row key={i} idx={i+1} primary={r.meccanico} sub={`${r.movimenti} movimenti`} value={r.pezzi} unit="pz" />
          ))}
        </Panel>
        <Panel icon={Wrench} title="Per macchina/matricola (180g)" wide>
          {machines.length === 0 ? <Empty/> : machines.map((r,i)=>(
            <Row key={i} idx={i+1} primary={r.macchina || "—"} sub={`${r.matricola} ${r.cliente?`• ${r.cliente}`:""}`} value={r.pezzi} unit="pz" />
          ))}
        </Panel>
      </div>

      <div className="gm-card">
        <div className="p-5 border-b border-zinc-800 flex items-center gap-2">
          <Truck className="text-[#4CAF50]" size={18} />
          <h3 className="font-display text-xl font-bold uppercase tracking-tight">Giacenze Officine Mobili</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-zinc-800">
          <div className="p-4 md:col-span-1">
            <div className="text-xs uppercase tracking-widest text-zinc-500 mb-3">Seleziona furgone</div>
            <div className="space-y-2">
              {officine.map(o => (
                <button key={o.id} onClick={()=>loadStock(o.id)} className={`w-full text-left p-3 border ${selectedOff===o.id?"border-[#4CAF50] bg-[#4CAF50]/5":"border-zinc-800 hover:border-zinc-700"}`} data-testid="report-officina-card">
                  <div className="font-semibold">{o.nome}</div>
                  <div className="text-xs text-zinc-500 font-mono-data">{o.targa || "—"}{o.assegnato_a?` • ${o.assegnato_a}`:""}</div>
                </button>
              ))}
            </div>
          </div>
          <div className="p-4 md:col-span-2">
            {!selectedOff ? <div className="text-sm text-zinc-500">Seleziona un furgone per vedere la giacenza interna.</div> : (
              stock.length === 0 ? <Empty msg="Furgone vuoto" /> :
              <table className="gm-table">
                <thead><tr><th>Codice</th><th>Descrizione</th><th className="text-right">Q.tà</th></tr></thead>
                <tbody>
                  {stock.map(s => (
                    <tr key={s.product_id}>
                      <td className="font-mono-data text-[#4CAF50]">{s.codice_interno}</td>
                      <td>{s.descrizione}</td>
                      <td className="text-right font-mono-data font-bold">{s.giacenza}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const Panel = ({icon: Icon, title, children, wide}) => (
  <div className={`gm-card ${wide?"lg:col-span-2":""}`}>
    <div className="p-5 border-b border-zinc-800 flex items-center gap-2">
      <Icon className="text-[#4CAF50]" size={18} />
      <h3 className="font-display text-xl font-bold uppercase tracking-tight">{title}</h3>
    </div>
    <div className="divide-y divide-zinc-800/50 max-h-96 overflow-y-auto">{children}</div>
  </div>
);
const Row = ({idx, primary, sub, value, unit}) => (
  <div className="p-4 flex items-center gap-3">
    <div className="font-display text-2xl font-black text-zinc-700 w-8">{idx}</div>
    <div className="flex-1 min-w-0">
      <div className="font-semibold truncate">{primary}</div>
      <div className="text-xs text-zinc-500 font-mono-data truncate">{sub}</div>
    </div>
    <div className="text-right">
      <div className="font-display text-2xl font-black">{value}</div>
      <div className="text-[10px] uppercase tracking-widest text-zinc-500">{unit}</div>
    </div>
  </div>
);
const Empty = ({msg="Nessun dato"}) => <div className="p-6 text-sm text-zinc-500">{msg}</div>;
